import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

export const SummaryStep = () => {
  const { t } = useTranslation("workflow", { keyPrefix: "parts.rollForwardWizard" });

  // TODO: [SP-11688] replace placeholder with the Summary step
  return <Typography variant="bodyRegular">{t("stepPlaceholder", { name: t("steps.summary") })}</Typography>;
};
